import React, { Component, useEffect, useState } from "react";
import Moment from "react-moment";
import PageHeader from "../Comman/PageHeader";
import CandidatePay from "./CandidatePay";
import PurchaseOrders from "./PurchaseOrders";
import http from "../../Services/httpService";
import auth from "../../Services/authService";
import config from "../../config.json";
import AddNewTimeLog from "./AddNewTimeLog";
import UploadInvoice from "./UploadInvoice";
import AddEditNotes from "./AddEditNotes";
import {
  formatTotalHours,
  getAllMonths, getAllYears, getFieldData, getFormatedNumber,
  getMonthLastDay, getMonthName, getTotalDays, getTotalHours
} from "../../Services/appService";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllRates, getTimeLogDuration, getTimeLogs, loadAllRates, loadTimeLogDuration, loadTimeLogs } from "../../app/store/timeLog";
import { getTimeLogDeleteReqStatus, getTimeLogInvoice, loadTimeLogInvoice, timeLogInvDocDeleteReq } from "../../app/store/timeLogInvoice";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import useDocDownload from "../../app/hooks/useDocDownload";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";

const CANDIDATE_INVOICE_STYLES = {
  pageActions: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "8px 0 10px"
  },
  backButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700
  },
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)",
    boxShadow: "0 14px 34px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    flexWrap: "wrap"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0
  },
  titleIcon: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    fontSize: "16px"
  },
  title: {
    fontSize: "18px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px"
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.6,
    color: "#64748b",
    margin: 0
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700
  },
  cardBody: {
    padding: "18px 22px 22px"
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  statCard: {
    borderRadius: "18px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px"
  },
  statValue: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1
  },
  statHint: {
    fontSize: "12px",
    lineHeight: 1.5,
    color: "#64748b",
    marginTop: "6px"
  },
  utilityRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "14px"
  },
  utilityPanel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "14px",
    padding: "14px 16px",
    borderRadius: "18px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)",
    width: "100%",
    flexWrap: "wrap"
  },
  utilityPanelTop: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flex: 1,
    minWidth: 0
  },
  utilityIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    flexShrink: 0
  },
  utilityCopy: {
    minWidth: 0,
    flex: 1
  },
  utilityLabel: {
    fontSize: "11px",
    fontWeight: 800,
    color: "#64748b",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    margin: 0
  },
  utilityValue: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.2,
    marginTop: "2px"
  },
  filterGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "14px",
    marginBottom: "16px"
  },
  fieldLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "8px"
  },
  inputShell: {
    borderRadius: "14px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    minHeight: "44px",
    boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.03)"
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflowX: "auto",
    overflowY: "visible",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
  },
  table: {
    marginBottom: 0,
    minWidth: "1120px"
  },
  candidateSummaryTable: {
    marginBottom: 0
  },
  tableHeadCell: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px",
    whiteSpace: "nowrap",
    verticalAlign: "top"
  },
  tableHeadSubtext: {
    display: "block",
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "none",
    color: "#94a3b8",
    marginTop: "4px"
  },
  cell: {
    verticalAlign: "top",
    padding: "18px 16px",
    borderTop: "1px solid rgba(226, 232, 240, 0.75)",
    fontSize: "13px",
    color: "#334155"
  },
  candidateSummaryCell: {
    verticalAlign: "middle",
    padding: "18px 16px",
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff"
  },
  idPill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 10px",
    borderRadius: "999px",
    backgroundColor: "#e0f2fe",
    color: "#075985",
    fontSize: "12px",
    fontWeight: 700,
    marginBottom: "8px"
  },
  secondaryPill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: "999px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 600
  },
  candidateName: {
    margin: 0,
    color: "#0f172a",
    fontSize: "15px",
    fontWeight: 700,
    textTransform: "uppercase"
  },
  infoText: {
    display: "block",
    color: "#475569",
    fontSize: "13px",
    lineHeight: 1.5
  },
  onboardingBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 12px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minHeight: "36px",
    borderRadius: "999px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    padding: "7px 14px",
    fontSize: "12px",
    fontWeight: 700,
    textDecoration: "none",
    whiteSpace: "normal",
    lineHeight: 1.25,
    textAlign: "center"
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "34px",
    padding: "0 12px",
    borderRadius: "999px",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    color: "#1d4ed8",
    fontSize: "13px",
    fontWeight: 800,
    border: "1px solid rgba(191, 219, 254, 1)",
    whiteSpace: "nowrap"
  },
  periodText: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "6px",
    cursor: "pointer"
  },
  metricButton: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "4px",
    padding: "8px 12px",
    borderRadius: "14px",
    background: "linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)",
    border: "1px solid rgba(219, 234, 254, 1)",
    boxShadow: "inset 0 0 0 1px rgba(255, 255, 255, 0.7)",
    color: "#0f172a",
    cursor: "pointer",
    textAlign: "left"
  },
  metricButtonPrimary: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: 800
  },
  metricButtonSecondary: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#64748b"
  },
  primaryText: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a"
  },
  mutedText: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.5,
    marginTop: "4px"
  },
  moneyText: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "4px"
  },
  invoiceStack: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    maxWidth: "280px"
  },
  invoiceItem: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px"
  },
  invoiceRequestText: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#92400e",
    backgroundColor: "#fffbeb",
    border: "1px solid rgba(253, 230, 138, 1)",
    borderRadius: "999px",
    padding: "7px 12px",
    lineHeight: 1.2,
    whiteSpace: "nowrap"
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "999px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent"
  },
  successPill: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)"
  },
  warningPill: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)"
  },
  dangerPill: {
    color: "#991b1b",
    backgroundColor: "#fef2f2",
    borderColor: "rgba(254, 202, 202, 1)"
  },
  textButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "6px",
    borderRadius: "999px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    fontSize: "12px",
    fontWeight: 700,
    padding: "7px 12px",
    textDecoration: "none",
    whiteSpace: "nowrap",
    lineHeight: 1.2,
    maxWidth: "240px",
    minHeight: "34px"
  },
  docList: {
    listStyle: "none",
    margin: "8px 0 0 0",
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: "8px"
  },
  docRow: {
    padding: 0,
    border: "none",
    background: "transparent"
  },
  paymentStack: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minWidth: "210px",
    maxWidth: "260px"
  },
  paymentCard: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
    boxShadow: "0 10px 22px rgba(15, 23, 42, 0.04)",
    padding: "12px"
  },
  paymentButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(187, 247, 208, 1)",
    background: "#f0fdf4",
    color: "#166534",
    fontSize: "12px",
    fontWeight: 800,
    padding: "8px 12px",
    lineHeight: 1.2
  },
  paidAmountPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 11px",
    fontSize: "12px",
    fontWeight: 800,
    marginTop: "8px"
  },
  paymentMeta: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5,
    marginTop: "8px"
  },
  paymentDocs: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "8px",
    marginTop: "10px"
  },
  emptyState: {
    padding: "22px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "13px"
  }
};

export default function CandidateInvoice() {

  const route = [
    { name: "Contract Management", url: "" },
    { name: "Invoices and Payments", url: "/PartnerInvoices" },
  ];


  const usrType = localStorage.getItem("userType");

  const [timeLogs, setTimeLogs] = useState([]);
  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [invType, setInvType] = useState("subcontractor");
  const [rate, setRate] = useState(0);
  const [performerData, setPerformerData] = useState("");
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [entType, setEntType] = useState("");
  const [w9Type, setW9Type] = useState("");
  const [costBefenifit, setCostBefenifit] = useState("");
  const [candidateObj, setCandidateObj] = useState(null);
  const [notesType, setNotesType] = useState(usrType === "recruiter" ? "TimeLogRecruiter" : "TimeLog");
  const [selectedItem, setSelectedItem] = useState(null);
  const [noteShowHide, setNoteShowHide] = useState(false);
  const [timeLogObj, setTimeLogObj] = useState(null);
  const [filterYear, setFilterYear] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [showHide, setShowHide] = useState(false);
  const [payShowHide, setPayShowHide] = useState(false);
  const [showHideTimeLog, setShowHideTimeLog] = useState(false);
  const [invShowHide, setInvShowHide] = useState(false);
  const [poShowHide, setPoShowHide] = useState(false);
  const [allRates, setAllRates] = useState([]);

  const [handleDownloadFile] = useDocDownload();

  const years = getAllYears();
  const months = getAllMonths();

  const timeLogsSelector = useSelector(getTimeLogs);
  const timeLogInvoiceSelector = useSelector(getTimeLogInvoice);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const allRatesSelector = useSelector(getAllRates);
  const timeLogDeleteReqStatusSelector = useSelector(getTimeLogDeleteReqStatus);


  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Candidate Invoice Detail"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    const state = location.state;
    if (state) {
      setSelectedItem(state);
      let rate = 0;
      if (usrType === "recruiter" && state.rates) {
        setNotesType("TimeLogRecruiter");
        rate = state.rates.recruiterRate;
      }
      if (usrType === "subcontractor" && state.rates) {
        rate = state.rates.subcontractorRate;
        setNotesType("TimeLog");
      }
      setRate(rate);
      setInvType(usrType);

      setPerformerData(state.performerData);
      dispatch(loadTimeLogs(state.performerid));
      dispatch(loadTimeLogInvoice(state.performerid));
      dispatch(loadTimeLogDuration(state.performerid));
      dispatch(loadAllRates(state.performerid));
      setCandidateObj(state);

      const entType = getFieldData(state.performerData, "candidateonboardingform", "CandidateEntity");
      setEntType(entType);
      const w9Type = getFieldData(state.performerData, "candidateonboardingform", "w9_Type");
      setW9Type(w9Type);
      const costBefenifit = getFieldData(state.performerData, "candidateonboardingform", "Cost_of_Benefit");
      setCostBefenifit(costBefenifit);
    }
  }, []);

  useEffect(() => {
    // Sort by year and month (latest first) when data first loads
    const sortedTimeLogs = [...timeLogsSelector].sort((a, b) => {
      const yearA = parseInt(a.year) || 0;
      const yearB = parseInt(b.year) || 0;
      const monthA = parseInt(a.month) || 0;
      const monthB = parseInt(b.month) || 0;

      // Sort by year descending, then month descending
      if (yearA !== yearB) return yearB - yearA;
      return monthB - monthA;
    });
    setTimeLogs(sortedTimeLogs);
  }, [timeLogsSelector])

  useEffect(() => {
    if (timeLogInvoiceSelector.length > 0) {
      const filterInvoices = timeLogInvoiceSelector.filter(x => x.invoiceType === invType);
      setTimeLogInvoices(filterInvoices);
    }
    else {
      setTimeLogInvoices([]);
    }

    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate() + 1); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }
  }, [timeLogInvoiceSelector]);

  useEffect(() => {
    let filterTimeLogs = [...timeLogsSelector];

    // Sort by year and month (latest first)
    filterTimeLogs.sort((a, b) => {
      const yearA = parseInt(a.year) || 0;
      const yearB = parseInt(b.year) || 0;
      const monthA = parseInt(a.month) || 0;
      const monthB = parseInt(b.month) || 0;

      // Sort by year descending, then month descending
      if (yearA !== yearB) return yearB - yearA;
      return monthB - monthA;
    });

    if (filterYear > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.year === parseInt(filterYear));

    if (filterMonth > 0)
      filterTimeLogs = filterTimeLogs.filter(x => x.month === parseInt(filterMonth));

    setTimeLogs(filterTimeLogs);

  }, [filterMonth, filterYear])

  useEffect(() => {
    setAllRates(allRatesSelector);
    console.log("allRatesSelector", allRatesSelector);
  }, [allRatesSelector])

  const getApplicableRateDetails = (item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);
    const rateField = usrType === "recruiter" ? "recruiterRate" : "subcontractorRate";
    const dateField = usrType === "recruiter" ? "recruiterEffectiveDate" : "subcontractorEffectiveDate";

    const matchedRate = Array.isArray(allRates)
      ? allRates.reduce((best, rate, index) => {
        if (!itemYear || !itemMonth) return best;

        const effMs = new Date(rate?.[dateField]).getTime();
        if (Number.isNaN(effMs)) return best;

        const effDt = new Date(effMs);
        const effYear = effDt.getFullYear();
        const effMonth = effDt.getMonth() + 1;
        const isApplicable =
          effYear < itemYear ||
          (effYear === itemYear && effMonth <= itemMonth);

        if (!isApplicable) return best;
        if (!best) return { rate, index, effMs };

        if (effMs > best.effMs) return { rate, index, effMs };
        if (effMs < best.effMs) return best;

        const addedMs = new Date(rate?.addedDateTime).getTime();
        const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
        const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
        const safeBestAddedMs = Number.isNaN(bestAddedMs) ? -Infinity : bestAddedMs;

        if (safeAddedMs > safeBestAddedMs) return { rate, index, effMs };
        if (safeAddedMs < safeBestAddedMs) return best;

        const idNum = Number(rate?.id);
        const bestIdNum = Number(best.rate?.id);
        const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
        const safeBestIdNum = Number.isFinite(bestIdNum) ? bestIdNum : -Infinity;

        if (safeIdNum > safeBestIdNum) return { rate, index, effMs };
        if (safeIdNum < safeBestIdNum) return best;

        return index > best.index ? { rate, index, effMs } : best;
      }, null)?.rate
      : null;

    const fallbackRate = parseFloat(rate || 0);
    const rateValue =
      matchedRate?.[rateField] !== null &&
        matchedRate?.[rateField] !== undefined &&
        matchedRate?.[rateField] !== ""
        ? parseFloat(matchedRate[rateField])
        : fallbackRate;

    const effectiveDate = matchedRate?.[dateField] || rate;

    return {
      rate: rateValue,
      effectiveDate,
    };
  };

  const getInvoiceAmount = (item) => {
    const totHrs = getTotalHours(item?.workingHrs || 0);
    const { rate: applicableRate } = getApplicableRateDetails(item);
    let invAmt = totHrs * applicableRate;

    // If not W2, return straight amount
    if (entType !== "W2 Basis") {
      return parseFloat(invAmt || 0).toFixed(2);
    }

    // W2 → add tax
    const taxRate = (getFieldData(performerData, "candidateonboardingform", "Tax") || 0) / 100;
    invAmt = invAmt + invAmt * taxRate;

    return parseFloat(invAmt || 0).toFixed(2);
  };

  const getFinalAmout = (obj) => {
    let fAmt = parseFloat(getInvoiceAmount(obj) || 0);

    const invItems = timeLogInvoices.filter(
      (x) => x.timeLogId === obj.id
    );

    if (invItems.length === 0) {
      return fAmt.toFixed(2);
    }

    const item = invItems[0];

    const adjMinus = parseFloat(item?.adjustmentMinues || 0);
    const adjPlus = parseFloat(item?.adjustmentPlus || 0);
    const adp = parseFloat(item?.adpDeduction || 0);

    // Apply adjustments
    fAmt = fAmt - adjMinus + adjPlus - adp;

    return fAmt.toFixed(2);
  };

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";

    let wt;
    try {
      wt = JSON.parse(obj.workingHrs);
    } catch (e) {
      return "";
    }

    if (!Array.isArray(wt) || wt.length === 0) return "";

    const sortWt = [...wt].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );

    const first = sortWt[0];
    const last = sortWt[sortWt.length - 1];

    const lastDate =
      last.type === "m"
        ? getMonthLastDay(last.start)
        : last.start;

    return (
      <div>
        <Moment format="MM/DD/YYYY">{first.start}</Moment>
        {" - "}
        <Moment format="MM/DD/YYYY">{lastDate}</Moment>
      </div>
    );
  };

  const getShortDocumentName = (name = "") => {
    if (!name) return "Document";
    return name.length > 15 ? `${name.substring(0, 15)}...` : name;
  };

  const getInvoiceDeduction = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) =>
        x.timeLogId === item.id
        && x.adpDeduction !== null
    );
    if (tmLogs.length === 0) {
      return "";
    }
    return <>
      {tmLogs.map((inv) => (
        <React.Fragment key={inv.id}>
          <div style={CANDIDATE_INVOICE_STYLES.moneyText}>{inv.adpDeduction}</div>
          <br />
          {inv?.adpDocList?.map(
            (doc) => (
              <button
                key={doc.id || doc.documentName}
                className="btn btn-sm"
                style={CANDIDATE_INVOICE_STYLES.textButton}
                title={doc.documentName}
                onClick={() =>
                  handleDownloadFile(
                    doc.invDoc
                  )
                }
              >
                <i className="fa fa-paperclip" aria-hidden="true"></i>
                {getShortDocumentName(doc.documentName)}
              </button>
            )
          )}
          {inv?.adpDocList?.length > 0 && <br />}
          <div style={CANDIDATE_INVOICE_STYLES.mutedText}>
            <Moment format="MMM Do YYYY, h:mm a">
              {inv.adpDateTime}
            </Moment>
          </div>
        </React.Fragment>
      ))}
    </>
  }

  const getGeneratedInvoice = (item) => {
    const tmStatus = timeLogInvoices.filter((x) =>
      x.timeLogId === item.id && x.status !== null);

    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.invDoc !== null);
    if (tmLogs.length === 0) {
      return (
        <div style={CANDIDATE_INVOICE_STYLES.invoiceStack}>
          <button
            className="btn btn-sm"
            style={CANDIDATE_INVOICE_STYLES.textButton}
            onClick={() =>
              handleInvShowHide(item)
            }
            disabled={tmStatus[0]?.status === false}
          >
            <i className="fa fa-upload" aria-hidden="true"></i>
            Upload / Generate
          </button>
        </div>
      );
    }

    return <div style={CANDIDATE_INVOICE_STYLES.invoiceStack}>
      {tmLogs.map((inv) => (
        <div key={inv.id} style={CANDIDATE_INVOICE_STYLES.invoiceItem}>
          <div style={CANDIDATE_INVOICE_STYLES.primaryText}>{inv.invoiceNumber}</div>

          <button
            className="btn btn-sm"
            style={CANDIDATE_INVOICE_STYLES.textButton}
            title={inv.invDoc.documentName}
            onClick={() => handleDownloadFile(inv.invDoc)}
          >
            <i className="fa fa-file-text-o" aria-hidden="true"></i>
            {getShortDocumentName(inv.invDoc.documentName)}
          </button>
          {!tmStatus[0]?.status && (
            inv.notes === "delete" ? (
              <span style={CANDIDATE_INVOICE_STYLES.invoiceRequestText}>
                Request Sent to Delete
              </span>
            ) : (
              <button
                type="button"
                className="btn btn-sm"
                style={CANDIDATE_INVOICE_STYLES.textButton}
                title="Delete Request Invoice Document"
                //disabled={isLocked}
                onClick={() => handleDeleteInvoiceDoc(inv.id)}
              >
                <i className="fa fa-trash" /> Send Request to Delete
              </button>
            )
          )}

        </div>
      ))}
    </div>
  }

  const handleDeleteInvoiceDoc = async (id) => {
    const result = await getConfirmAlert("", "Are you sure you want to send request to delete this document?", "error");
    if (result.isConfirmed) {
      dispatch(timeLogInvDocDeleteReq(id))
    }
  }

  useEffect(() => {
    if (timeLogDeleteReqStatusSelector) {
      getAlert("", "Request Sent Successfully.", "success");
      if (candidateObj?.performerid)
        dispatch(loadTimeLogInvoice(candidateObj.performerid));
    }
  }, [timeLogDeleteReqStatusSelector])

  const getInvoiceStatus = (item) => {
    const tmLogs = timeLogInvoices.filter((x) =>
      x.timeLogId === item.id && x.status !== null);

    if (tmLogs.length > 0) {
      return <>
        {tmLogs.map((inv) => (
          <React.Fragment key={inv.id}>
            {inv.status === true && (
              <span style={{ ...CANDIDATE_INVOICE_STYLES.statusPillBase, ...CANDIDATE_INVOICE_STYLES.successPill }}>
                <i className="fa fa-check" aria-hidden="true"></i> Approved
              </span>
            )}
            {inv.status === false && (
              <span style={{ ...CANDIDATE_INVOICE_STYLES.statusPillBase, ...CANDIDATE_INVOICE_STYLES.dangerPill }}>
                <i className="fa fa-times" aria-hidden="true"></i> Rejected
              </span>
            )}
            <br />
            <div style={CANDIDATE_INVOICE_STYLES.mutedText}>
              <Moment format="MMM Do YYYY">
                {inv.reviewDateTime}
              </Moment>
            </div>
          </React.Fragment>
        ))}
      </>
    }

    return "";
  }

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id &&
        x.paymentMode !== null
    );

    if (tmLogs.length > 0) {
      return (
        <div style={CANDIDATE_INVOICE_STYLES.paymentStack}>
          {tmLogs.map((pay) => (
            <div key={pay.id}>
              <button
                className="btn btn-sm"
                style={CANDIDATE_INVOICE_STYLES.paymentButton}
                onClick={() => handlePayShowHide(pay)}
              >
                <i className="fa fa-money" aria-hidden="true"></i>
                Paid by IPCS
              </button>
              <br />
              <div style={CANDIDATE_INVOICE_STYLES.paidAmountPill}>
                <i className="fa fa-usd" aria-hidden="true"></i>
                Paid: {pay.paidAmount || "0.00"}
              </div>
              {pay.docList?.length > 0 && (
                <div style={CANDIDATE_INVOICE_STYLES.paymentDocs}>
                  {pay.docList.map((doc) => (
                    <button
                      key={doc.id || doc.documentName}
                      className="btn btn-sm"
                      style={CANDIDATE_INVOICE_STYLES.textButton}
                      title={doc.documentName}
                      onClick={() => handleDownloadFile(doc)}
                    >
                      <i className="fa fa-paperclip" aria-hidden="true"></i>
                      {getShortDocumentName(doc.documentName)}
                    </button>
                  ))}
                </div>
              )}
              <br />
              {pay.payDateTime && (
                <div style={CANDIDATE_INVOICE_STYLES.paymentMeta}>
                  <i className="fa fa-calendar-o" aria-hidden="true"></i>
                  <Moment format="MMM Do YYYY">
                    {pay.payDateTime}
                  </Moment>
                </div>
              )}
            </div>
          ))}
        </div>
      );
    }
    return "";
  }

  const getDueAmountStatus = (item) => {
    const tmLogs = timeLogInvoices
      .filter(
        (x) =>
          x.timeLogId === item.id &&
          x.paidAmount !== null
      );
    if (tmLogs.length === 0) return "";

    return <>
      {tmLogs.map((inv) => parseFloat(getFinalAmout(item) - inv.paidAmount).toFixed(2))}
    </>

  }

  const handlePayShowHide = (obj) => {
    setPayShowHide(!payShowHide);
    setTimeLogObj(obj);
  };

  const handleInvShowHide = (obj) => {
    if (obj === "save") {
      if (selectedItem?.performerid) {
        dispatch(loadTimeLogs(selectedItem.performerid));
        dispatch(loadTimeLogInvoice(selectedItem.performerid));
      }
      setInvShowHide(false);
      setTimeLogObj(null);
    }
    else {
      setInvShowHide(!invShowHide);
      setTimeLogObj(obj);
    }

  };

  const handlePoShowHide = () => {
    setPoShowHide(!poShowHide);
  };

  const handleInvoiceDetailsFocus = () => {
    const invoiceDetailsSection = document.getElementById("candidate-invoice-details");

    if (invoiceDetailsSection) {
      invoiceDetailsSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  };

  const getPendingPoCount = (obj) => (
    obj?.poTypes?.filter(
      (po) => po.type === usrType && po.partnerSign !== true && po.sendStatus === true
    ).length || 0
  );

  const getTotalPoCount = (obj) => (
    obj?.poTypes?.filter((po) => po.type === usrType && po.sendStatus === true).length || 0
  );

  const getPoCount = (obj) => {
    const pendingCount = getPendingPoCount(obj);
    const totalCount = pendingCount === 0 ? getTotalPoCount(obj) : pendingCount;
    const badgeClass = pendingCount === 0 ? "badge-success" : "badge-danger";

    return (
      <span className={`badge badge-pill ${badgeClass} ml-2`}>
        {totalCount}
      </span>
    );
  };

  const getOnboardingBadgeStyle = (isComplete) => ({
    ...CANDIDATE_INVOICE_STYLES.onboardingBadge,
    color: isComplete ? "#166534" : "#92400e",
    backgroundColor: isComplete ? "#dcfce7" : "#fef3c7",
    border: `1px solid ${isComplete ? "rgba(187, 247, 208, 1)" : "rgba(253, 230, 138, 1)"}`
  });

  const handleShowHide = (obj) => {
    setShowHide(!showHide);
    setTimeLogObj(obj);
  };

  const handleNotesComments = (type, obj) => {
    if (type === "save") {
      setTimeLogObj(null);
      setNoteShowHide(false);
    } else {
      setTimeLogObj(obj);
      setNoteShowHide(!noteShowHide);
    }
  };


  let item = "";
  if (selectedItem)
    item = selectedItem;

  const showInvoiceColumn = entType === "C2C Basis" || usrType === "recruiter";
  const emptyInvoiceColSpan =
    9 +
    (w9Type === "W2 Hourly with Benefits" ? 1 : 0) +
    (entType === "W2 Basis" && usrType !== "recruiter" ? 1 : 0) +
    (showInvoiceColumn ? 1 : 0);
  const totalInvoiceHours = timeLogs.reduce(
    (sum, log) => sum + (Number(getTotalHours(log?.workingHrs || 0)) || 0),
    0
  );
  const formatNumericHours = (hours) => {
    const totalMinutes = Math.round((Number(hours) || 0) * 60);
    const finalHours = Math.floor(totalMinutes / 60);
    const finalMinutes = totalMinutes % 60;

    return `${finalHours}h ${finalMinutes}m`;
  };
  const totalInvoiceDays = timeLogs.reduce(
    (sum, log) => sum + (Number(getTotalDays(log?.workingHrs || 0)) || 0),
    0
  );
  const reviewedInvoices = timeLogs.filter((log) =>
    timeLogInvoices.some((invoice) => invoice.timeLogId === log.id && invoice.status !== null)
  ).length;
  const paidInvoices = timeLogs.filter((log) =>
    timeLogInvoices.some((invoice) => invoice.timeLogId === log.id && Number(invoice.paidAmount) > 0)
  ).length;
  const totalFinalPay = timeLogs.reduce(
    (sum, log) => sum + (Number(getFinalAmout(log)) || 0),
    0
  );
  const formatProjectDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "" : date.toISOString().substring(0, 10);
  };
  const projectDateLabel = formatProjectDate(projectStDt) || formatProjectDate(currentStDt) || "Not available";

  return (
    <React.Fragment>

      <style>{`
        .candidate-invoice-table tbody tr:hover td {
          background-color: #f8fbff !important;
        }

        @media (max-width: 991.98px) {
          .candidate-invoice-table {
            min-width: 1100px;
          }
        }
      `}</style>

      <div className="col-md-12" style={CANDIDATE_INVOICE_STYLES.pageActions}>
        <button
          className="btn btn-sm"
          style={CANDIDATE_INVOICE_STYLES.backButton}
          onClick={() => navigate(-1)}
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div className="col-md-12 form-group">
        <div className="table-responsive" style={CANDIDATE_INVOICE_STYLES.tableWrap}>
          <table className="table align-items-center table-hover mb-0 candidate-invoice-table" style={CANDIDATE_INVOICE_STYLES.candidateSummaryTable}>
            <thead>
              <tr>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Details</th>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Agency</th>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Onboarding<br />Status</th>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Purchase Order</th>
                <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Action</th>
              </tr>
            </thead>
            <tbody>
              {item !== "" &&
                <tr>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    <span style={CANDIDATE_INVOICE_STYLES.idPill}>{item.performerid}</span>
                    <br />
                    <span style={CANDIDATE_INVOICE_STYLES.secondaryPill}>
                      IPCS ID: {item.maxloans || "N/A"}
                    </span>
                  </td>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    <p style={CANDIDATE_INVOICE_STYLES.candidateName}>
                      {item.performername} {item.lastName}
                    </p>
                    <span style={CANDIDATE_INVOICE_STYLES.infoText}>
                      {item.performeremail || "Email not available"}
                    </span>
                    <span style={CANDIDATE_INVOICE_STYLES.infoText}>
                      {item.contactNo ? getFormatedNumber(item.contactNo) : "Phone not available"}
                    </span>
                    <span style={CANDIDATE_INVOICE_STYLES.infoText}>
                      {getFieldData(
                        item.performerData,
                        "projectengagement",
                        "PositionTitle"
                      ) || "Position title not available"}
                    </span>
                  </td>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    <span style={CANDIDATE_INVOICE_STYLES.infoText}>
                      {getFieldData(
                        item.performerData,
                        "projectengagement",
                        "AgencyName"
                      ) || "Agency not available"}
                    </span>
                  </td>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    {item.duration && (
                      <React.Fragment>
                        <span style={CANDIDATE_INVOICE_STYLES.infoText}>{item.duration.duration} Months</span>
                        <span style={CANDIDATE_INVOICE_STYLES.infoText}>
                          Start:{" "}
                          <Moment format="MMM Do YYYY">
                            {item.duration.startDate}
                          </Moment>
                        </span>
                        <span style={CANDIDATE_INVOICE_STYLES.infoText}>
                          End:{" "}
                          <Moment format="MMM Do YYYY">
                            {item.duration.endDate}
                          </Moment>
                        </span>
                      </React.Fragment>
                    )}
                    {!item.duration && (
                      <span style={CANDIDATE_INVOICE_STYLES.infoText}>Duration not available</span>
                    )}
                  </td>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    <span style={getOnboardingBadgeStyle(item.appSubmit)}>
                      {item.appSubmit ? "Complete" : "Pending"}
                    </span>
                  </td>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    <button
                      className="btn btn-sm"
                      onClick={() => handlePoShowHide(item)}
                      style={CANDIDATE_INVOICE_STYLES.actionButton}
                    >
                      View and eSign
                      {getPoCount(item)}
                    </button>
                  </td>
                  <td style={CANDIDATE_INVOICE_STYLES.candidateSummaryCell}>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleInvoiceDetailsFocus}
                      style={CANDIDATE_INVOICE_STYLES.actionButton}
                    >
                      Invoice Details
                    </button>
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-md-12">
        <div id="candidate-invoice-details" className="card shadow-none" style={CANDIDATE_INVOICE_STYLES.card}>
          <div className="card-header" style={CANDIDATE_INVOICE_STYLES.cardHeader}>
            <div style={CANDIDATE_INVOICE_STYLES.headerRow}>
              <div style={CANDIDATE_INVOICE_STYLES.titleWrap}>
                <span style={CANDIDATE_INVOICE_STYLES.titleIcon}>
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                </span>
                <div>
                  <h2 style={CANDIDATE_INVOICE_STYLES.title}>Invoice Details</h2>
                  <p style={CANDIDATE_INVOICE_STYLES.subtitle}>
                    Review time logs, invoice generation, IPCS review, and payment activity.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body" style={CANDIDATE_INVOICE_STYLES.cardBody}>
            <div style={CANDIDATE_INVOICE_STYLES.statsRow}>
              <div style={CANDIDATE_INVOICE_STYLES.statCard}>
                <div style={CANDIDATE_INVOICE_STYLES.statLabel}>Invoice Periods</div>
                <div style={CANDIDATE_INVOICE_STYLES.statValue}>{timeLogs.length}</div>
                <div style={CANDIDATE_INVOICE_STYLES.statHint}>Time log periods available for invoicing.</div>
              </div>
              <div style={CANDIDATE_INVOICE_STYLES.statCard}>
                <div style={CANDIDATE_INVOICE_STYLES.statLabel}>Total Hours</div>
                <div style={CANDIDATE_INVOICE_STYLES.statValue}>{formatNumericHours(totalInvoiceHours)}</div>
                <div style={CANDIDATE_INVOICE_STYLES.statHint}>{totalInvoiceDays} working day{totalInvoiceDays === 1 ? "" : "s"} across visible periods.</div>
              </div>
              <div style={CANDIDATE_INVOICE_STYLES.statCard}>
                <div style={CANDIDATE_INVOICE_STYLES.statLabel}>Reviewed / Paid</div>
                <div style={CANDIDATE_INVOICE_STYLES.statValue}>{reviewedInvoices} / {paidInvoices}</div>
                <div style={CANDIDATE_INVOICE_STYLES.statHint}>Invoices reviewed by IPCS and invoices with payment activity.</div>
              </div>
              <div style={CANDIDATE_INVOICE_STYLES.statCard}>
                <div style={CANDIDATE_INVOICE_STYLES.statLabel}>Final Pay</div>
                <div style={CANDIDATE_INVOICE_STYLES.statValue}>{totalFinalPay.toFixed(2)}</div>
                <div style={CANDIDATE_INVOICE_STYLES.statHint}>Combined final pay amount for visible invoice periods.</div>
              </div>
            </div>
            <div style={CANDIDATE_INVOICE_STYLES.utilityRow}>
              <div style={CANDIDATE_INVOICE_STYLES.utilityPanel}>
                <div style={CANDIDATE_INVOICE_STYLES.utilityPanelTop}>
                  <span style={CANDIDATE_INVOICE_STYLES.utilityIcon}>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                  </span>
                  <div style={CANDIDATE_INVOICE_STYLES.utilityCopy}>
                    <div style={CANDIDATE_INVOICE_STYLES.utilityLabel}>Date Started On The Project</div>
                    <div style={CANDIDATE_INVOICE_STYLES.utilityValue}>{projectDateLabel}</div>
                  </div>
                </div>
              </div>
            </div>
            <div style={CANDIDATE_INVOICE_STYLES.filterGrid}>
              <div>
                <label
                  htmlFor="filterYear"
                  style={CANDIDATE_INVOICE_STYLES.fieldLabel}
                >
                  Invoice Year
                </label>
                <select
                  name="filterYear"
                  id="year"
                  className="form-control"
                  style={CANDIDATE_INVOICE_STYLES.inputShell}
                  value={filterYear}
                  onChange={({ currentTarget }) => setFilterYear(currentTarget.value)}
                >
                  <option value="">Year</option>
                  {years.map((y) => (
                    <option key={y.name} value={y.name}>{y.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  htmlFor="filterMonth"
                  style={CANDIDATE_INVOICE_STYLES.fieldLabel}
                >
                  Invoice Month
                </label>
                <select
                  name="filterMonth"
                  id="month"
                  className="form-control"
                  style={CANDIDATE_INVOICE_STYLES.inputShell}
                  value={filterMonth}
                  onChange={({ currentTarget }) => setFilterMonth(currentTarget.value)}
                >
                  <option value="">Month</option>
                  {months.map((m) => (
                    <option key={m.id} value={m.id}>{m.name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive" style={CANDIDATE_INVOICE_STYLES.tableWrap}>
                  <table className="table align-items-center table-hover mb-0 candidate-invoice-table" style={CANDIDATE_INVOICE_STYLES.table}>
                    <thead>
                      <tr>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Year</th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Month</th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Period</th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Hours<span style={CANDIDATE_INVOICE_STYLES.tableHeadSubtext}>Days</span></th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Rate/Hr<span style={CANDIDATE_INVOICE_STYLES.tableHeadSubtext}>Amount ($)</span></th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Invoice
                          <span style={CANDIDATE_INVOICE_STYLES.tableHeadSubtext}>Amount ($)</span>
                        </th>
                        {w9Type === "W2 Hourly with Benefits" && (
                          <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Cost of benefit ($)</th>
                        )}
                        {entType === "W2 Basis" && usrType !== "recruiter" && (
                          <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>ADP Deduction ($)</th>
                        )}
                        {showInvoiceColumn && (
                          <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Invoice</th>
                        )}
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Review Status</th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Final Pay<span style={CANDIDATE_INVOICE_STYLES.tableHeadSubtext}>Amount ($)</span></th>
                        <th style={CANDIDATE_INVOICE_STYLES.tableHeadCell}>Payment<span style={CANDIDATE_INVOICE_STYLES.tableHeadSubtext}>Amount ($)</span></th>
                        {/* <th>Due Amount ($)</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {timeLogs.map((item) => (
                        <tr key={item.id}>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <div style={CANDIDATE_INVOICE_STYLES.primaryText}>{item.year}</div>
                          </td>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <div style={CANDIDATE_INVOICE_STYLES.primaryText}>{getMonthName(item.month)}</div>
                          </td>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <button
                              type="button"
                              className="btn btn-sm"
                              style={CANDIDATE_INVOICE_STYLES.periodText}
                              onClick={() => handleShowHide(item)}
                            >
                              <i className="fa fa-calendar-o" aria-hidden="true"></i>
                              {getMonthlyPeriod(item)}
                            </button>
                            <ul style={CANDIDATE_INVOICE_STYLES.docList}>
                              {item.docList?.map((doc) => (
                                <li key={doc.id || doc.documentName} className="list-group-item" style={CANDIDATE_INVOICE_STYLES.docRow}>
                                  <button
                                    className="btn btn-sm"
                                    style={CANDIDATE_INVOICE_STYLES.textButton}
                                    title={doc.documentName}
                                    onClick={() => handleDownloadFile(doc)}
                                  >
                                    <i className="fa fa-paperclip" aria-hidden="true"></i>
                                    {getShortDocumentName(doc.documentName)}
                                  </button>

                                </li>
                              ))}
                            </ul>
                          </td>

                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <button
                              type="button"
                              className="btn btn-sm"
                              style={CANDIDATE_INVOICE_STYLES.metricButton}
                              onClick={() => handleShowHide(item)}
                            >
                              <span style={CANDIDATE_INVOICE_STYLES.metricButtonPrimary}>
                                <i className="fa fa-clock-o" aria-hidden="true"></i>
                                {formatTotalHours(item?.workingHrs)}
                              </span>
                              <span style={CANDIDATE_INVOICE_STYLES.metricButtonSecondary}>
                                {`${getTotalDays(item.workingHrs)} ${getTotalDays(item.workingHrs) === 1 || getTotalDays(item.workingHrs) === 0 ? "Day" : "Days"}`}
                              </span>
                            </button>
                          </td>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            {(() => {
                              const { rate, effectiveDate } = getApplicableRateDetails(item);
                              return (
                                <>
                                  <div style={CANDIDATE_INVOICE_STYLES.moneyText}>{rate}</div>
                                  {effectiveDate && (
                                    <div style={CANDIDATE_INVOICE_STYLES.mutedText}>
                                      <Moment format="MMM Do YYYY">
                                        {effectiveDate}
                                      </Moment>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </td>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <div style={CANDIDATE_INVOICE_STYLES.moneyText}>{getInvoiceAmount(item)}</div>
                          </td>
                          {w9Type === "W2 Hourly with Benefits" && (
                            <td style={CANDIDATE_INVOICE_STYLES.cell}>{costBefenifit}</td>
                          )}
                          {entType === "W2 Basis" && usrType !== "recruiter" && (
                            <td style={CANDIDATE_INVOICE_STYLES.cell}>
                              {getInvoiceDeduction(item)}
                            </td>
                          )}
                          {showInvoiceColumn && (
                            <td style={CANDIDATE_INVOICE_STYLES.cell}>
                              {getGeneratedInvoice(item)}
                            </td>
                          )}

                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <button
                              className="btn btn-sm"
                              style={CANDIDATE_INVOICE_STYLES.textButton}
                              onClick={() => handleNotesComments("", item)}
                            >
                              <i className="fa fa-commenting-o" aria-hidden="true"></i>
                              View <span className="badge badge-pill badge-success mt--1 text-dark">{item?.allComments.filter(x => x.commentType === notesType).length}</span>
                            </button>
                          </td>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            <div style={CANDIDATE_INVOICE_STYLES.moneyText}>{getFinalAmout(item)}</div>
                            {getInvoiceStatus(item)}
                          </td>
                          <td style={CANDIDATE_INVOICE_STYLES.cell}>
                            {getPaymentStatus(item)}
                          </td>
                          {/* <td>
                            {getDueAmountStatus(item)}
                          </td> */}
                        </tr>
                      ))}
                      {timeLogs.length === 0 && (
                        <tr>
                          <td
                            colSpan={emptyInvoiceColSpan}
                            style={CANDIDATE_INVOICE_STYLES.emptyState}
                          >
                            No invoice records found for the selected filters.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        candidateObj={item}
        selectedObj={timeLogObj}
        timeLogsData={timeLogs}
      ></CandidatePay>

      <AddNewTimeLog
        showHide={showHide}
        handleShowHide={handleShowHide}
        selectedObj={timeLogObj}
        candidateObj={item}
        viewType="invoice"
        allTimeLogs={timeLogs}
        projectStartDate={projectStDt}
      ></AddNewTimeLog>

      <UploadInvoice
        invShowHide={invShowHide}
        handleInvShowHide={handleInvShowHide}
        candidateObj={item}
        selectedObj={timeLogObj}
        timeLogInvoices={timeLogInvoices}
        allRates={allRates}
        entType={entType}
      ></UploadInvoice>
      <PurchaseOrders
        poShowHide={poShowHide}
        handlePoShowHide={handlePoShowHide}
        candidateObj={item}
      ></PurchaseOrders>
      {noteShowHide &&
        <AddEditNotes
          noteShowHide={noteShowHide}
          handleNoteShowHide={handleNotesComments}
          notesType={notesType}
          candidateObj={item}
          timeLogObj={timeLogObj}
        ></AddEditNotes>}
    </React.Fragment>
  );
}
